var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('Header'),_c('Breadcrumb',{attrs:{"items":_vm.items,"title":"Részletek"}}),_c('ServiceDetailsWrapper'),_c('BrandCarousel',{attrs:{"addClass":"grey-bg"}}),_c('Footer'),_c('OffCanvasMobileMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }